module.exports = __webpack_public_path__ + "media/svg/gerant-6824653a.svg";